let overlayLockCount = 0;
let previousOverflow = '';
let overlayVisualLayerSequence = 0;

export function nextOverlayVisualLayer(): number {
  overlayVisualLayerSequence += 1;
  return overlayVisualLayerSequence;
}

export function acquireOverlayBodyLock(): () => void {
  if (typeof document === 'undefined') return () => undefined;
  if (overlayLockCount === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.dataset.overlayLocked = 'true';
  }
  overlayLockCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    overlayLockCount = Math.max(0, overlayLockCount - 1);
    if (overlayLockCount === 0) {
      document.body.style.overflow = previousOverflow;
      delete document.body.dataset.overlayLocked;
    }
  };
}
